<template>
    <div class="form-group">
        <label>Codice nuovo corso</label>
        <input class="form-control" type="text" v-model="code">
        <br>
        <button class="btn btn--green" @click="checkUniqueCode()">Clona</button>

    </div>
</template>

<script>

export default {
  mounted() {
      this.code = this.course_code;
    },
    data () {
        return {
          code : ""
        }
    },
    methods: {

        cloneCourse(){
            let params = {
                code: this.code
            }
            axios.post("/post-training-plans/"+this.training_plan_id+"/"+this.course_id+"/clone", params).then((response) => {
                Vue.swal.fire({
                      title: 'Corso Clonato',
                      text: "",
                    }
                );
                window.close();
            }).catch(function(error){
              alert(error);
            });

        },

        checkUniqueCode(){

          if(this.code =="" || this.code=== null){
            Vue.swal.fire({
                  title: 'Codice obbligatorio',
                  text: "",
                }
            );
            return;
          }

            let params = {
              training_plan : this.training_plan_id,
              course        : this.course_id,
              code          : this.code
            }

            axios.get("/check-unique-course-code/"+this.training_plan_id+"/"+this.course_id, {params: params}).then((response) => {

              if(response.data < 1){
                this.cloneCourse();
              }
              else{
                Vue.swal.fire({
                      title: 'Codice già inserito',
                      text: "",
                    }
                );
              }

            }).catch(function(error){
              alert(error);
            });




      }
    },
    props: {
        course_id: {
            type: Number,
            required: true
        },
        course_code: {
            type: String,
            required: true
        },
        training_plan_id: {
            type: Number,
            required: true
        },

    }
}
</script>

<style>
  /*.custom-actions button.ui.button {
    padding: 8px 8px;
  }
  .custom-actions button.ui.button > i.icon {
    margin: auto !important;
  }*/
</style>
